module.exports = __webpack_public_path__ + "img/icon-active.a96a0c33.svg";